import { useLayoutEffect, useRef, useState, type ReactNode } from 'react';

/** Keep board geometry square as surrounding live panels and fullscreen space change. */
export function TeacherObservationBoardFrame({ children }: { children: ReactNode }) {
  const frame = useRef<HTMLDivElement>(null);
  const [size, setSize] = useState<number>();
  useLayoutEffect(() => {
    const element = frame.current;
    if (!element) return;
    const fit = () => {
      const { width, height } = element.getBoundingClientRect();
      if (width > 0 && height > 0) {
        const next = Math.floor(Math.min(width, height));
        setSize((previous) => (previous === next ? previous : next));
      }
    };
    const observer = new ResizeObserver(fit);
    observer.observe(element);
    fit();
    return () => observer.disconnect();
  }, []);
  return (
    <div className="teacher-observation-board-frame" ref={frame}>
      <div
        className="teacher-observation-fitted-board"
        style={size === undefined ? undefined : { width: size, height: size }}
      >
        {children}
      </div>
    </div>
  );
}
